// src/components/EventCard.jsx
import React from "react";
import { Card, Btn, Stars } from "./UI";

export default function EventCard({ ev, saved, onSave, onOpen }) {
  return (
    <Card onClick={() => onOpen(ev.id)} style={{ margin: "0 16px 12px", overflow: "hidden" }}>
      {/* Image */}
      <div style={{ height: 145, background: ev.grad, position: "relative", display: "flex", alignItems: "flex-end", padding: 10 }}>
        <span style={{ fontSize: 10, padding: "3px 10px", borderRadius: 20, background: "rgba(255,255,255,0.22)", color: "#fff", fontWeight: 500 }}>
          {ev.cat.charAt(0).toUpperCase() + ev.cat.slice(1)}
        </span>
        {ev.live && (
          <span style={{ position: "absolute", top: 10, left: 10, background: "#1D9E75", color: "#fff", fontSize: 9, padding: "3px 8px", borderRadius: 20, display: "flex", alignItems: "center", gap: 4 }}>
            <span style={{ width: 5, height: 5, borderRadius: "50%", background: "#fff", display: "inline-block" }} />
            Live now
          </span>
        )}
        <span style={{ position: "absolute", top: 10, right: 10, background: "#fff", color: "#111", fontSize: 10, padding: "3px 9px", borderRadius: 20, fontWeight: 500 }}>
          {ev.date}
        </span>
      </div>
      {/* Body */}
      <div style={{ padding: "10px 13px 12px" }}>
        <div style={{ fontSize: 14, fontWeight: 500, color: "#111", marginBottom: 3 }}>{ev.title}</div>
        <div style={{ fontSize: 11, color: "#666", display: "flex", gap: 6, marginBottom: 6 }}>
          <span>{ev.venue}</span><span>·</span><span>{ev.time}</span>
          <span style={{ marginLeft: "auto", fontWeight: 500, color: "#7F77DD" }}>{ev.priceLabel}</span>
        </div>
        {ev.rating && (
          <div style={{ display: "flex", alignItems: "center", gap: 5, marginBottom: 6 }}>
            <Stars value={ev.rating} size={11} />
            <span style={{ fontSize: 11, color: "#999" }}>{ev.rating} ({ev.ratingCount})</span>
          </div>
        )}
        <div style={{ display: "flex", gap: 5, flexWrap: "wrap", marginBottom: 8 }}>
          {ev.highlights.slice(0, 3).map((h) => (
            <span key={h} style={{ fontSize: 10, background: "#f5f5f5", color: "#666", padding: "2px 8px", borderRadius: 20 }}>{h}</span>
          ))}
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }} onClick={(e) => e.stopPropagation()}>
          <Btn variant="ghost" onClick={() => onSave(ev.id)} style={{ padding: "6px 12px", fontSize: 11, color: saved ? "#7F77DD" : "#666", border: `0.5px solid ${saved ? "#7F77DD" : "rgba(0,0,0,0.18)"}`, background: saved ? "#EEEDFE" : "none" }}>
            {saved ? "✓ Saved" : "Save"}
          </Btn>
          <Btn variant="primary" onClick={() => onOpen(ev.id)} style={{ padding: "6px 14px", fontSize: 11 }}>
            View
          </Btn>
        </div>
      </div>
    </Card>
  );
}
